import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-wellness-white py-16 px-6" data-id="element-89">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-xl mx-auto text-center" data-id="element-90">
        <div className="bg-wellness-light-sage/30 rounded-2xl p-8" data-id="element-91">
          <div className="w-16 h-16 bg-wellness-green rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-92">
            <ShieldCheck className="w-8 h-8 text-white" data-id="element-93" />
          </div>

          <h3 className="text-xl font-serif font-bold text-wellness-dark mb-3" data-id="element-94">
            Garantía de satisfacción — 7 días
          </h3>

          <p className="text-wellness-dark/70" data-id="element-95">
            Prueba la guía durante 7 días. Si sientes que no es para ti,
            escríbenos y te devolvemos tu dinero. Así de simple.
          </p>
        </div>
      </motion.div>
    </section>;
}